module.exports = {
  Japanese: 'ja-JP',
  English: 'en-US',
  Chinese: 'zh-CN',
  Korean: 'ko-KR',
};
